import { InvoiceStatus } from '@link/agent/services/const';

export default {
  common: {
    search: '搜尋',
    keyword: '關鍵字',
    cancelAll: '批次取消',
    complete: '完成'
  },
  layouts: {
    sidebar: {
      notifications: '通知',
      contractsList: '合約管理',
      agents: '旅行社管理',
      booking: '預訂',
      settings: '設定',
      changePassword: '更改密碼',
      finance: '付款管理',
      bulkOrder: '批次預訂',
      activityList: '在售商品一覽'
    }
  },
  views: {
    activityList: {
      pageTitle: '在售商品一覽',
      searchTitle: '商品檢索',
      activityId: '商品ID',
      activityUrl: '商品URL',
      title: '商品名',
      supplier: '供應商',
      supplierId: '供應商ID',
      supplierName: '供應商名',
      category: '類別',
      country: '商品國家・地區',
      confirmationType: '庫存類型',
      inSalePeriod: '銷售期間內',
      unspecified: '不指定',
      salePeriod: '銷售期間',
      netPrice: '批發價',
      grossPrice: '銷售價（GROSS）',
      unlimited: '無期限',
      downloadCsv: '下載CSV',
      snapshotHint:
        '顯示的資料為前一天的資料（每日深夜更新）。最後更新時間：{{time}}'
    },
    bulkBookingDetail: {
      history: '操作內容',
      action: '操作',
      operator: '操作者',
      date: '日期',
      message: '訊息',
      notifyPayment: '匯款通知',
      paymentDate: '匯款日',
      paymentConfirmed: '已確認匯款',
      infoSentToSupplier: '已將資訊發送至供應商'
    },
    bulkBookingForm: {
      operator: '操作者',
      paymentDate: '預計匯款日',
      message: '訊息',
      agentReservationNo: '旅行社預訂編號（備註）',
      agentReservationNote: '旅行社預訂須知'
    },
    addPrepayment: {
      agentId: '旅行社 ID',
      agentName: '旅行社名稱',
      address: '公司地址',
      date: '付款期限',
      currency: '貨幣',
      amount: '付款金額',
      note: '請將預付請款書以電子郵件寄送至 LINKTIVITY 業務負責人。',
      submit: '建立預付請款書',
      reset: '重置'
    },
    financeHistory: {
      title: '付款記錄',
      dataAggregation: '數據彙總',
      aggregationUnit: '彙總單位',
      targetPeriod: '期間範圍',
      monthly: '月度',
      weekly: '雙週',
      confirmed: '已確定',
      canceledRefund: '取消退款',
      differenceAdjusted: '差額已調整',
      totalAmount: '合計金額',
      cancellationFee: '（含取消費用）',
      totalPaymentAmount: '付款金額合計',
      price: '({{currency}})',
      salesPrice: '銷售價格',
      wholesalePrice: '批發價格',
      commission: '手續費',
      transactionSearch: '交易查詢',
      applicationDate: '申請日',
      participationDate: '參加日',
      transactionStatus: '交易狀態',
      keyword: '關鍵字',
      activity: '商品',
      plan: '方案',
      supplier: '供應商',
      reservationNumber: '預訂編號',
      currency: '貨幣'
    },
    financeTransactions: {
      title: '結算報表',
      transactionStatus: '結算狀態',
      difference: '差異調整',
      dueDate: '帳單開立日期',
      invoiceNumber: '帳單ID',
      date: '請款週期',
      fromDate: '{{fromDate}}～{{toDate}}',
      currency: '貨幣單位',
      amount: '付款金額合計',
      adjustedAmount: '調整金額',
      finalAmount: '最終合計金額',
      adjust: '調整',
      showjust: '顯示',
      change: '已付款',
      invoice: '帳單明細',
      jaInvoice: '支付通知書(日文)',
      jaInvoiceDetails: '明細書(日文)',
      enInvoice: '支付通知書(英文)',
      enInvoiceDetails: '明細書(英文)',
      attachment: '附件',
      changeTitle: '是否已付款？',
      changeMessage: '交易狀態將變更為「已付款」'
    },
    financeAccount: {
      title: '餘額管理',
      listTitle: '儲值紀錄',
      accountBalance: '帳戶餘額',
      accountBuffer: '帳戶緩衝金',
      deposit: '進行儲值',
      generatePrepaidInvoice: '建立預付請款書',
      billingCycle: '結算週期',
      paymentMethod: '付款方式',
      currency: '貨幣',
      contractNote: '上述設定依據合約內容。',
      contactSupport: '如需變更，請聯絡 LINKTIVITY 負責人。',
      date: '日期時間',
      amount: '金額',
      prepaidInvoice: '預付請款書',
      transactionStatus: '狀態',
      remark: '備註',
      accountBalanceAmount: '帳戶前餘額',
      accountBalanceAfterAmount: '儲值後餘額',
      accountBufferAmount: '帳戶緩衝金',
      verificationCode: '確認碼',
      enterDepositAmount: '請輸入儲值金額',
      depositAmount: '儲值金額',
      proceedToPayment: '前往付款流程',
      chargeCompleted: '匯款完成',
      cancel: '取消',
      confirmChargeCompleted: '將向 LINKTIVITY 通知匯款完成。',
      changeStatusToCharged: '將狀態變更為「匯款完成」。',
      change: '操作',
      confirmCancel: '是否要取消？',
      changeStatusToCancelled: '將狀態變更為「已取消」。',
      insufficientBalanceNotification: '設定餘額不足通知',
      notificationDialogTitle: '餘額不足通知設定',
      notificationDialogSubtitle:
        '當餘額低於指定金額時，將透過電子郵件通知您。',
      notificationReceiveLabel: '接收通知',
      notificationEnabled: '接收',
      notificationDisabled: '不接收',
      notificationThresholdLabel: '指定金額',
      notificationSave: '儲存設定'
    },
    dashboard: {
      title: '儀表板'
    },
    searchActivities: {
      title: '新預訂',
      filter: {
        lang: '翻譯語言',
        otaId: '旅行社',
        supplierId: '供應商',
        categories: '分類',
        country: '出發地',
        activityTitle: '商品名稱'
      },
      plan: '方案',
      openBookingForm: '開啟預訂表單',
      viewDetail: '查看詳情',
      total: '搜尋結果：{{total}}筆',
      location: '{{country}}',
      city: '・{{city}}',
      supplier: '{{name}}({{id}})'
    },
    activityDetail: {
      plan: '選擇方案',
      plans: {
        stockAndPrice: '庫存與價格',
        calendar: '庫存日曆',
        priceCalendar: '價格日曆',
        quantity: '庫存數量',
        currentPrice: '當日價格',
        noDateSelected: '請選擇日期',
        unit: '單位',
        displayPrice: '銷售價格',
        netPrice: '批發價格',
        otherDate: '其他適用日期',
        priceTable: '價格表',
        priceGroup: '價格群組',
        applicablePeriod: '適用期間',
        cannotBeBookIndependently: '不可單獨購買',
        commission: '手續費'
      }
    },
    bookingForm: {
      title: '預訂表單',
      steps: {
        step1: '基本資訊',
        step2: '預訂時必要資訊',
        step3: '預訂申請'
      },
      prev: '上一步',
      next: '下一步',
      form: {
        plans: '方案',
        targetDate: '參加日',
        time: '開始時間',
        amount: '人數',
        amountDesc: '預訂數量限制：{{capacity}}',
        amountDescBulk:
          '預訂數量限制：{{capacity}}；每次預訂每個單位最多 999 張。',
        accountBalance: '帳戶餘額',
        availableAmount: '可用金額',
        checkPrice: '確認空位與價格',
        checkList: '參加限制',
        checkListTip: '請於預訂前確認',
        operator: '操作者',
        paymentDate: '預計匯款日',
        message: '訊息',
        requiredInfo: '必要資訊',
        requiredInfoPerParticipant: '必要資訊（每位參加者）',
        allotmentQuantity: '數量 {{quantity}}',
        paymentCurrency: '付款金額（銷售價格）',
        totalPriceForBooking: '當地貨幣總金額',
        paymentCurrencyExchange: '匯率',
        unit: '單位',
        representative: '參加者代表',
        pleaseSelectUnit: '請選擇單位',
        displayPrice: '銷售價格',
        netPrice: '批發價格'
      },
      bookingConfirmation: {
        title: '您的預訂已被受理',
        message: '申請已完成，資訊已發送至供應商',
        reservationNumber: '預訂編號',
        print: '列印用',
        display: '顯示用'
      },
      participantInfo: {
        firstName: '代表人（名）',
        lastName: '代表人（姓）',
        agentReservationNo: '旅行社預訂編號（備註）',
        agentReservationNote: '旅行社預訂特記事項'
      },

      bookingFields: {
        participantEmailAddress: '參加者電子郵件',
        hotelName: '住宿名稱',
        hotelAddress: '住宿地址',
        hotelReservationLastName: '住宿代表人姓名（姓）',
        hotelReservationFirstName: '住宿代表人姓名（名）',
        hotelReservationName: '住宿代表人姓名',
        hotelTel: '住宿電話號碼',
        arrivalDate: '當地抵達日',
        arrivalTime: '抵達時間',
        arrivalFlightNumber: '航班抵達班次',
        departureDate: '出發日',
        departureTime: '出發時間',
        departureFlightNumber: '航班出發班次',
        destinationEmail: '當地聯絡方式（電子郵件）',
        destinationTel: '當地聯絡方式（電話號碼）',
        gender: '性別',
        agentChannelRegion: '旅行社所在國・地區',
        agentChannelLanguage: '旅行社使用語言',
        participantResidentRegion: '參加者居住國家/地區',
        participantLanguage: '參加者使用語言',
        passengersQuantity: '乘車人數',
        prescriptionMaskQuantityFree: '是否需要有度數面鏡 ※免費',
        prescriptionMaskQuantityPaid: '是否需要有度數面鏡 ※現場付款',
        preferredStartTime: '希望開始時間',
        preferredPickUpLocation: '接送／上車地點',
        preferredDropOffLocation: '送達／下車地點',
        participantsQuantity: '參加人數',
        luggageQuantity: '行李箱數量（總計）',
        childrenWithoutSeatQuantity: '不佔座嬰幼兒',
        childSeatQuantityPaid: '是否使用兒童座椅 ※現場付款',
        childSeatQuantityFree: '是否使用兒童座椅 ※免費',
        guideJa: '希望日文導覽',
        driverJa: '希望日文司機',
        guideEn: '希望英文導覽',
        driverEn: '希望英文司機',
        guideZh: '希望中文導覽',
        driverZh: '希望中文司機',
        guideKo: '希望韓文導覽',
        driverKo: '希望韓文對應司機',
        preferredGuideLanguageCode: '希望導覽語言',
        preferredDriverLanguageCode: '希望司機語言',
        passportNationality: '國籍',
        passportFirstName: '參加者名字（護照羅馬拼音）',
        passportLastName: '參加者姓氏（護照羅馬拼音）',
        dateOfBirth: '出生日期',
        age: '年齡',
        passportNumber: '護照號碼',
        eyesight: '視力',
        weightKg: '體重（kg）',
        heightCm: '身高（cm）',
        shoeSizeCm: '鞋碼（cm）',
        weightLbs: '體重（lbs）',
        heightIn: '身高（ft/in）',
        clothesSize: '衣服尺寸',
        vegetarianMeals: '是否需要素食餐',
        divingExperienceTimes: '潛水經驗次數',
        rentalEquipmentsFree: '是否需要器材租借 ※免費',
        rentalEquipmentsPayLocally: '是否需要器材租借 ※現場付款',
        male: '男性',
        female: '女性',
        other: '其他',
        yes: '是',
        no: '否'
      },

      alert: {
        warning: '您所選日期的可用庫存數量少於所需人數，請變更日期或人數。',
        info: '同意取消政策並提交申請',
        cannotBookAlone: '所選票券不可單獨購買。'
      }
    },
    reservations: {
      title: '未確定的預訂'
    },
    agentDetail: {
      title: '旅行社資訊'
    },
    orgList: {
      title: '群組管理'
    },
    agentAccountList: {
      title: '帳戶管理'
    },
    bookReservations: {
      paymentAppliedDate: '付款申請日',
      id: 'ID',
      productPlan: '商品/方案',
      expirationDate: '有效期限',
      participationDate: '參加日期（當地商品）',
      holdReservation: '未確定的預訂',
      count: '筆'
    }
  },
  const: {
    allotmentStatus: {
      plenty: '有庫存',
      insufficient: '庫存剩餘不多',
      empty: '無庫存',
      unavailable: '不可販售'
    },
    bookingStatus: {
      yes: '可預訂',
      no: '不可預訂'
    },
    activityTags: {
      NON_CANCELLABLE: '不可取消',
      FREE_CANCEL_BEFORE_ISSUE_TICKET: '兌換前可免費取消',
      ADVANCE_CANCELLATION_POLICY: '特殊取消政策',
      INSTANT_BOOK: '立即預訂',
      NON_QR_CODE: '人工驗證憑證',
      QR_CODE: 'QR憑證',
      ETICKET: '電子驗票票券（需手機）'
    },
    invoiceStatus: {
      [InvoiceStatus.InvoiceStatusPending]: '未付款',
      [InvoiceStatus.InvoiceStatusConfirmed]: '付款完成',
      [InvoiceStatus.InvoiceStatusPaid]: '待入帳確認',
      [InvoiceStatus.InvoiceStatusCancelled]: '已取消'
    }
  }
};
